





































import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import { Job, CrudDialogMode, FetchJobsPayload, CreateJobPayload, UpdateJobPayload, DataTableAction } from '../utils/types'
import JobCrud from '../components/JobCrud.vue'
import DataTable from '../components/DataTable.vue'
@Component({
  components: { JobCrud, DataTable }
})
export default class Jobs extends Vue {
  @Getter jobs!: Job[]
  @Getter totalJobs!: number
  @Action fetchJobs!: (payload: FetchJobsPayload) => Promise<void>
  @Action createJob!: (payload: CreateJobPayload) => Promise<boolean>
  @Action deleteJob!: (payload: { id: string }) => Promise<void>
  @Action updateJob!: (payload: UpdateJobPayload) => Promise<boolean>
  currentCrudDialogMode = CrudDialogMode.NONE
  crudDialogMode = CrudDialogMode
  searchTimeout = 0
  isLoading = false
  itemsPerPage = 100
  currentJob: Job | null = null

  headers = [
    { text: 'שם', value: 'name' },
    { text: 'האם מאומתת', value: 'isVerified' },
    { text: 'משתמשים מחוברים', value: 'users.length' },
    { text: 'ענף', value: 'branch.name' }
  ];

  item: Job | null = null
  search = ''

  async fetchPage (page: number, searchText?: string): Promise<void> {
    this.isLoading = true
    await this.fetchJobs({
      limit: this.itemsPerPage,
      page,
      searchText: searchText
    })
    this.isLoading = false
  }

  async mounted () {
    this.isLoading = true
    await this.fetchPage(1)
    this.isLoading = false
  }

  async searchJobListing (searchText: string) {
    this.isLoading = true
    await this.fetchPage(1, searchText)
    this.isLoading = false
  }

  openDialog (mode: CrudDialogMode, item: Job | null = null) {
    this.currentJob = this.jobs.find(j => j.id === item?.id) || item
    this.currentCrudDialogMode = mode
    this.item = this.currentJob
  }

  get currentDialogTitle () {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        return 'יצירת עבודה חדשה'
      case CrudDialogMode.EDIT:
        return 'עריכת עבודה'
      case CrudDialogMode.DELETE:
        return 'למחוק את העבודה?'
    }
  }

  closeDialog () {
    this.currentCrudDialogMode = CrudDialogMode.NONE
    this.item = null
  }

  get dialog () {
    return this.currentCrudDialogMode !== CrudDialogMode.NONE
  }

  get jobActions (): DataTableAction<Job>[] {
    return [
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: this.openDialog.bind(this, CrudDialogMode.EDIT)
      }
    ]
  }

  get formattedJobs () {
    return this.jobs.map((j) => ({
      ...j,
      isVerified: this.translateIsVerified(j.isVerified)
    }))
  }

  translateIsVerified (isVerified: boolean | undefined) {
    return isVerified ? 'מאומתת' : 'לא מאומתת'
  }

  async handleSubmit (eventData: Job) {
    this.isLoading = true
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        await this.executeCreate(eventData)
        break
      case CrudDialogMode.EDIT:
        await this.executeUpdate(eventData)
        break
      case CrudDialogMode.DELETE:
        await this.executeDelete(eventData.id)
        break
    }
    this.isLoading = false
    this.closeDialog()
  }

  async executeCreate (eventData: Job) {
    const name = eventData.name || ''
    const branch = eventData.branch?.id || ''
    const address = eventData.address || ''
    if (name && branch && address) {
      await this.createJob({ name, branch, address })
    }
  }

  async executeUpdate (eventData: Job) {
    if (!eventData.id) {
      return
    }
    await this.updateJob({
      id: eventData.id,
      address: eventData.address,
      branch: eventData.branch?.id,
      isArchived: eventData.isArchived,
      isVerified: eventData.isVerified,
      name: eventData.name
    })
  }

  async executeDelete (eventData = '') {
    if (!eventData) return
    await this.deleteJob({ id: eventData })
  }
}
